/**
 * action types
 */
export const SET_ENROLMENTS = 'SET_ENROLMENTS';
export const ENROLMENTS_START = 'ENROLMENTS_START';
export const ENROLMENTS_SUCCESS = 'ENROLMENTS_SUCCESS';
export const ENROLMENTS_FAILED = 'ENROLMENTS_FAILED';
export const CHECK_ENROLMENTS = 'CHECK_ENROLMENTS';
export const SET_ENROLMENT_DISPLAYED = 'SET_ENROLMENT_DISPLAYED';
export const LEAVE_COHORTS = 'LEAVE_COHORTS';

export const COURSE_ENROLMENT_START = 'COURSE_ENROLMENT_START';
export const COURSE_ENROLMENT_FAILURE = 'COURSE_ENROLMENT_FAILURE';
export const DISMISS_COURSE_ENROLMENT_ERROR_MODAL =
  'DISMISS_COURSE_ENROLMENT_ERROR_MODAL';
export const COURSE_EXTERNAL_ENROLMENT_START =
  'COURSE_EXTERNAL_ENROLMENT_START';
export const COURSE_PAID_ENROLMENT_START = 'COURSE_PAID_ENROLMENT_START';
export const COURSE_ACCESS_CODE_ENROLMENT_START =
  'COURSE_ACCESS_CODE_ENROLMENT_START';
export const COURSE_ACCESS_CODE_ENROLMENT_CANCEL =
  'COURSE_ACCESS_CODE_ENROLMENT_CANCEL';
export const COURSE_PRE_ENROLMENT_QUESTIONS_ENROLMENT_START =
  'COURSE_PRE_ENROLMENT_QUESTIONS_ENROLMENT_START';
export const COURSE_ENROLMENT_CLASS_SELECTION_START =
  'COURSE_ENROLMENT_CLASS_SELECTION_START';
export const COURSE_ENROLMENT_CLASS_SELECTION_CANCEL =
  'COURSE_ENROLMENT_CLASS_SELECTION_CANCEL';
export const CHECK_COURSE_ENROLMENT_ACCESS_CODE_START =
  'CHECK_COURSE_ENROLMENT_ACCESS_CODE_START';
export const CHECK_COURSE_ENROLMENT_ACCESS_CODE_SUCCESS =
  'CHECK_COURSE_ENROLMENT_ACCESS_CODE_SUCCESS';
export const CHECK_COURSE_ENROLMENT_ACCESS_CODE_FAILURE =
  'CHECK_COURSE_ENROLMENT_ACCESS_CODE_FAILURE';
export const COURSE_ENROLMENT_ACCESS_CODE_CHANGE =
  'COURSE_ENROLMENT_ACCESS_CODE_CHANGE';
export const COURSE_ENROLMENT_CLASS_SELECTION_CHANGE =
  'COURSE_ENROLMENT_CLASS_SELECTION_CHANGE';
